

import {useCallback, useEffect, useMemo} from "react";
import {useApiCall} from "./useApiCall";

// Универсальный хук для загрузки данных при маунте компонента.
export const useFetch = <T, P extends any[] = any[]>(
    serviceCallback: (...args: P) => Promise<any>,
    params: P = [] as unknown as P,
    options?: { enabled?: boolean }
) => {
    const { execute, data, isLoading, error } = useApiCall<T>();

    const enabled = options?.enabled ?? true;

    // Мемоизируем параметры, чтобы useEffect не срабатывал без нужды
    const memoParams = useMemo(() => params, [params]);

    const fetchData = useCallback(() => {
        if (!enabled) return;
        execute(serviceCallback, ...memoParams);
    }, [enabled, execute, memoParams, serviceCallback])

    useEffect(() => {
        if (!enabled) return;
        fetchData();
    }, [enabled, fetchData]);


    return { data, isLoading, error, refetch: fetchData };
};
